// Components==============
import indexDream from 'actions/dream/index';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import { useRootModal } from 'hooks/useRootModal';
import { useTranslate } from 'hooks/useTranslate';
import { ReflectContext } from 'pages/Growth/Reflect/Reflect';
import React, { useContext, useEffect, useState } from 'react';
import Button from '../Button/Button';
import Modal from '../Modal/Modal';
import ReflectionIcon from '../ReflectionIcon/ReflectionIcon';
import Spinner from '../Spinner/Spinner';
import './DreamSelectModal.module.scss';
// =========================

type Props = {
  selected: number[];
  handleSubmit: (ids: number[]) => void;
};

const DModal = ({ handleSubmit, selected }: Props) => {
  const translate = useTranslate();
  const { closeModal } = useRootModal();
  const dispatch = useReduxAction();

  const dreams = useRedux((state) =>
    state?.dream?.entities.allIds
      .map((id) => state.dream?.entities.byId[id])
      .filter(
        (d) => !d?.is_public && d?.created_by === state.authentication?.user?.id
      )
  );

  const [selectedDreams, setSelectedDreams] = useState<number[]>(selected);

  useEffect(() => {
    dispatch(indexDream());
  }, []);

  function handleDreamClick(id: number) {
    if (selectedDreams.includes(id)) {
      setSelectedDreams((prev) => prev.filter((p) => p !== id));
    } else {
      setSelectedDreams([...selectedDreams, id]);
    }
  }

  return (
    <Modal size="medium">
      <div styleName="wrapper">
        <h2>{translate('dream.dream-contribute')}</h2>
        <strong>{translate('dream.terms.my-dreams')}</strong>
        <div styleName="dreams-wrapper">
          {dreams?.map(
            (dream) =>
              !!dream && (
                <ReflectionIcon
                  key={dream.id}
                  name={dream.name}
                  image={dream.image}
                  selected={!!selectedDreams.includes(dream.id)}
                  onClick={() => handleDreamClick(dream.id)}
                />
              )
          )}
        </div>
        <div styleName="button-wrapper">
          <Button color="grey" onClick={closeModal}>
            {translate('general.terms.cancel')}
          </Button>
          <Button
            onClick={() => {
              handleSubmit(selectedDreams);
              closeModal();
            }}
          >
            {translate('general.terms.add')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default function DreamSelectModal({
  white,
  handleSubmit,
  selected,
}: {
  white?: boolean;
} & Props) {
  const translate = useTranslate();
  const { dispatchingDreams } = useContext(ReflectContext);

  const { setModal } = useRootModal();

  return (
    <>
      <Button
        color={selected.length ? 'purple' : white ? 'white' : 'grey'}
        onClick={() =>
          setModal(<DModal selected={selected} handleSubmit={handleSubmit} />)
        }
      >
        {selected.length
          ? `${selected.length} ${translate(
              selected.length > 1 ? 'dream.terms.dreams' : 'dream.terms.dream'
            )}`
          : translate('dream.actions.contribute-to-dream')}
        <Spinner loading={!!dispatchingDreams} />
      </Button>
    </>
  );
}
